import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

const truthy = new Set(['1', 'true', 'yes', 'y']);

// True while the backend's headless browser renders a page for a PDF, so the app's banners and
// chat launcher stay out of the file. Set by ?pdfExport=1, and always on /pdf-table, which exists
// only for the SECR renderer. Not on /private: people open those report pages in the app too.
export function usePdfExportMode(): boolean {
  const location = useLocation();

  return useMemo(() => {
    if (typeof window === 'undefined') return false;
    if (location.pathname.startsWith('/pdf-table')) return true;
    const value = String(new URLSearchParams(location.search).get('pdfExport') || '').toLowerCase();
    return truthy.has(value);
  }, [location.pathname, location.search]);
}

